export class InvestmentObjective {
    isObjective: boolean;
    yearsTrading: string;
    tradesPerYear: string;
    knowledgeLevel: string;
    marginExperience: boolean | null;

    constructor() {
        this.isObjective = false;
    }
}
